const TYPE = Object.freeze({
  CW_20: 'cw20',
  CW_858: 'cw858',
});

export default Object.freeze({
  TYPE,
});
